import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import useComputedItems from 'hooks/useComputedItems';
import getCommonAndIndeterminateTags from './getCommonAndIndeterminateTags';
export function useHandleMultiSelectTags(_ref) {
  var initialContentItems = _ref.initialContentItems,
    contentIds = _ref.contentIds;
  var _getCommonAndIndeterm = getCommonAndIndeterminateTags({
      tags: (initialContentItems === null || initialContentItems === void 0 ? void 0 : initialContentItems.flatMap(function (pl) {
        return (pl.tags || []).map(function (tag) {
          return _objectSpread({
            contentId: pl.id
          }, tag);
        });
      })) || [],
      contentIds: contentIds
    }),
    _getCommonAndIndeterm2 = _getCommonAndIndeterm.all,
    allTags = _getCommonAndIndeterm2 === void 0 ? [] : _getCommonAndIndeterm2;
  var _useComputedItems = useComputedItems({
      initialItems: allTags
    }),
    tagsToAdd = _useComputedItems.itemsToAdd,
    tagsToRemove = _useComputedItems.itemsToRemove,
    computedTags = _useComputedItems.computedItems,
    wereTagsChanged = _useComputedItems.wasChanged,
    addTag = _useComputedItems.addItem,
    removeTag = _useComputedItems.removeItem,
    resetTags = _useComputedItems.reset;
  var selectedTags = computedTags.map(function (tag) {
    var tagIdsToAdd = tagsToAdd.map(function (tag) {
      return tag.id;
    });
    // Ensure that any previously indeterminate tags are set to no longer be indeterminate
    // once they have been selected as tags to add to all playlists
    if (tagIdsToAdd.includes(tag.id)) {
      return _objectSpread(_objectSpread({}, tag), {}, {
        isIndeterminate: false
      });
    }
    return tag;
  });
  return {
    wereTagsChanged: wereTagsChanged,
    selectedTags: selectedTags,
    tagsToRemove: tagsToRemove,
    tagsToAdd: tagsToAdd,
    addTag: addTag,
    removeTag: removeTag,
    resetTags: resetTags
  };
}
export default useHandleMultiSelectTags;